import {
    store
} from "./Store"
import AWSAppSyncClient, {
    createAppSyncLink
} from "aws-appsync";
import {
    AmplifyEventBus
} from './plugins/aws-amplify-vue';
import * as localForage from "./plugins/localforage";
Vue.prototype.$localForage = localForage
import Vue from "vue";
import {
    Auth
} from 'aws-amplify';
import VueApollo from "vue-apollo";
import {
    WebSocketLink
} from 'apollo-link-ws'
import ApolloLinkTimeout from 'apollo-link-timeout';
import {
    ApolloLink
} from 'apollo-link';
import {
    createHttpLink
} from 'apollo-link-http';
import {
    onError
} from 'apollo-link-error';
import {
    setContext
} from 'apollo-link-context';
const type = 'AWS_IAM'
const aws_exports = require('./exports').default;
const onErrorLink = onError(({
    graphQLErrors,
    networkError
}) => {
    if (graphQLErrors) {
        graphQLErrors.map(({
            message,
            locations,
            path
        }) => {
            console.log(
                ` [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
        });
    }
    if (networkError) {
        console.log(` [Network error]: ${networkError}`);
        console.log('Setting to offline...')
        store.commit('change', { onLine: false });
        store.commit('change', {
            netError: networkError
        });
    }
});
const timeoutLink = new ApolloLinkTimeout(32000)
const httpLink = createHttpLink({
    uri: aws_exports.ENDPOINT
});
/*
const resultsFetcherLink = ApolloLink.from([
  setContext(async (request, previousContext) => {
    const token = (await Auth.currentSession()).getAccessToken().getJwtToken();
    return {
      headers: {
        ...previousContext.headers,
        'access-token': token,
      },
    };
  }),
  createHttpLink({
    uri: aws_exports.ENDPOINT,
  }),
]);
*/
Vue.prototype.$appsyncURL = aws_exports.ENDPOINT
const appSyncLink = createAppSyncLink({
    url: aws_exports.ENDPOINT,
    region: aws_exports.REGION,
    path: aws_exports.PATH,
    auth: {
        //type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        type: 'AMAZON_COGNITO_USER_POOLS',
        jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
    },
    resultsFetcherLink: httpLink,
    complexObjectsCredentials: () => Auth.currentCredentials(),
    fetchPolicy: 'network-only'
});
const link = ApolloLink.from([
    onErrorLink,
    timeoutLink,
    //httpLink
    appSyncLink
])
const defaultClient = new AWSAppSyncClient({
    fetchPolicy: 'network-only',
    offlineConfig: {
        storage: localForage
    }
}, {
    link
});
Vue.prototype.$apolloClient = defaultClient

const apolloProvider = new VueApollo({
    defaultClient
});
Vue.prototype.$apolloProvider = apolloProvider

Vue.use(VueApollo);

export default apolloProvider;
